import { BrowserOptions, Hub } from '@sentry/browser';

// Only need one BrowserClient needed for the whole library
let clientPromise: Promise<Hub> | null = null;

const loadSentry = async () => {
  const {
    BrowserClient: BrowserClientConstructor,
    Hub: HubConstructor,
    makeMain,
    defaultIntegrations,
  } = await import('@sentry/browser');

  return {
    BrowserClientConstructor,
    HubConstructor,
    makeMain,
    defaultIntegrations,
  };
};

const initSentry = (
  { BrowserClientConstructor, HubConstructor, defaultIntegrations, makeMain },
  options: BrowserOptions = {},
) => {
  const client = new BrowserClientConstructor({
    integrations: [...defaultIntegrations],

    ...options,
  });

  const hub = new HubConstructor(client);

  // hub needs to be made main to capture everything
  // https://github.com/getsentry/sentry-javascript/issues/2356
  makeMain(hub);
  return hub;
};

export const getSentryClient = (options: BrowserOptions): Promise<Hub> => {
  if (clientPromise) {
    return clientPromise;
  }

  clientPromise = loadSentry().then((module) => initSentry(module, options));

  return clientPromise;
};
